export const NOTIFICATIONS = 'NOTIFICATIONS';
